import { ProximityPolicyRuleSubcategorySpecType } from '@warebee/frontend/data-access-api-graphql';
import _ from 'lodash';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useRecoilState, useRecoilValue } from 'recoil';
import TitleSection from '../components/layout/TitleSection';
import { getProximitySubcategoryOptions } from './proximityPolicy.helper';

import OrderedList, {
  OrderedListItem,
  OrderedListProps,
} from '../components/actions/OrderedList';
import { InputGroupList } from '../components/inputs/InputGroupList';
import {
  proximityPolicyRule,
  proximityPolicySelectedIdentity,
} from './proximityPolicy.state';

const ProximityPolicySubcategoriesEditor: React.FC = () => {
  const { t } = useTranslation('simulation');
  const selectedIdentity = useRecoilValue(proximityPolicySelectedIdentity);
  const [rule, updateRule] = useRecoilState(
    proximityPolicyRule(selectedIdentity?.ruleId),
  );
  if (selectedIdentity?.type !== 'subcategories' || !rule) return null;

  const options = getProximitySubcategoryOptions(t);

  const optionsMap = _.reduce(
    getProximitySubcategoryOptions(t),
    (acc, o) => ({
      ...acc,
      [o.id]: o.title,
    }),
    {} as Record<ProximityPolicyRuleSubcategorySpecType, string>,
  );

  function updateGroupBy(
    items: OrderedListItem<ProximityPolicyRuleSubcategorySpecType>[],
  ) {
    updateRule(current => ({
      ...current,
      subcategories: {
        ...current.subcategories,
        groupBy: _.map(items, i => ({
          type: i.type,
        })),
      },
    }));
  }

  function updateBreakBy(
    items: OrderedListItem<ProximityPolicyRuleSubcategorySpecType>[],
  ) {
    updateRule(current => ({
      ...current,
      subcategories: {
        ...current.subcategories,
        breakBy: _.map(items, i => ({
          type: i.type,
        })),
      },
    }));
  }

  const groupBySortOrderProps: OrderedListProps<ProximityPolicyRuleSubcategorySpecType> =
    {
      current: _.map(rule?.subcategories?.groupBy, p => ({
        type: p.type,
      })),
      options: optionsMap,
      onChange: updateGroupBy,
    };

  const breakBySortOrderProps: OrderedListProps<ProximityPolicyRuleSubcategorySpecType> =
    {
      current: rule?.subcategories?.breakBy,
      options: optionsMap,
      onChange: updateBreakBy,
    };

  return (
    <TitleSection
      id={`policy-editor-priorities`}
      title={t('Allocation Priorities')}
      inSidebarView
      hasScreenTitle
    >
      <InputGroupList className="space-y-2">
        <p className="text-menu-active p-2 text-base">{t('Split By')}</p>
        <OrderedList {...breakBySortOrderProps} />
        <p className="text-menu-active p-2 text-base">{t('Group By')}</p>
        <OrderedList {...groupBySortOrderProps} />
      </InputGroupList>
    </TitleSection>
  );
};

export default ProximityPolicySubcategoriesEditor;
